// extracted by mini-css-extract-plugin
export default {"header1":"SvVpKZ"};